// extracted by mini-css-extract-plugin
export default {"header":"YGGQl","content":"n9BDw","addButton":"WGiKT","spinner":"UwAvP"};